import { render, staticRenderFns } from "./LegalAssistantDrawerLite.vue?vue&type=template&id=95d2002a&scoped=true"
import script from "./LegalAssistantDrawerLite.vue?vue&type=script&lang=js"
export * from "./LegalAssistantDrawerLite.vue?vue&type=script&lang=js"
import style0 from "./LegalAssistantDrawerLite.vue?vue&type=style&index=0&id=95d2002a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d2002a",
  null
  
)

export default component.exports